import { oldApiInstance } from 'functions/request';

export const fetchTags = ({ user_token, token, page } = {}) =>
  oldApiInstance.get(token === 'all' ? '/lists/all' : `/lists/${token}`, {
    params: {
      user_token,
      page: page || 1,
    },
  });
